// formColumn.jsx
const columns = [
  {
    title: "Nama Cabang",
    dataIndex: "cabang",
    key: "cabang",
  },
  {
    title: "Kode Cabang",
    dataIndex: "kode_cabang",
    key: "kode_cabang",
  },
  {
    title: "Alamat",
    dataIndex: "alamat",
    key: "alamat",
  },
  {
    title: "Is Active",
    dataIndex: "isactive",
    key: "isactive",
    // rendering handled in MasterEmployee (Switch / Yes-No)
  },
];

const dataForm = [
  [
    {
      label: "Nama Cabang",
      key: "cabang",
      placeholder: "Nama Cabang",
      type: "text",
    },
  ],
  [
    {
      label: "Kode Cabang",
      key: "kode_cabang",
      placeholder: "Kode Cabang",
      type: "text",
    },
  ],
  [
    {
      label: "Alamat",
      key: "alamat",
      placeholder: "Alamat",
      type: "textarea",
    },
  ],
  [
    {
      label: "Is Active",
      key: "isactive",
      placeholder: "Is Active",
      type: "checkbox",
    },
  ],
];

export { columns, dataForm };
